import React, { useEffect } from 'react';

const About = ({ isVisible, onClose }) => {
  // Handle escape key to close modal
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isVisible) {
        onClose();
      }
    };

    if (isVisible) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isVisible, onClose]);

  if (!isVisible) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="about-modal" onClick={(e) => e.stopPropagation()}>
        <button className="close-button" onClick={onClose}>
          ×
        </button>
        
        <div className="about-content">
          <h1>About JFK Productions</h1>
          
          <div className="about-section">
            <h2>Our Story</h2>
            <p>
              JFK Productions was founded by Kraai Du Toit in April 2025, born from a passion 
              for visual storytelling and creative excellence.
            </p>
          </div>

          <div className="about-section">
            <h2>A Brief History</h2>
            <p>
              What began as a hobby in AI, animation, and video production has evolved into a 
              thriving career dedicated to bringing visions to life. Through continuous learning 
              and innovation, we've transformed our passion into professional expertise that 
              serves clients across various industries.
            </p>
          </div>

          <div className="about-section">
            <h2>Our Philosophy</h2>
            <div className="taglines">
              <blockquote>
                "A good product requires good representation. A great product will use 
                advertising to promote itself."
              </blockquote>
              <p>
                From corporate videos to television commercials, we help your business shine. 
                We believe that every brand has a unique story worth telling, and our mission 
                is to craft compelling visual narratives that resonate with your audience and 
                drive meaningful engagement.
              </p>
            </div>
          </div>

          <div className="about-section">
            <h2>What We Do</h2>
            <p>
              Specializing in AI-enhanced video production, animation, and creative content 
              development, we bring cutting-edge technology together with artistic vision to 
              deliver exceptional results for our clients.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;